import React, { useEffect, useRef, useState, useMemo } from "react";
import { createPortal } from "react-dom";
import {
  Overlay,
  Dialog,
  Header,
  Title,
  Desc,
  Actions,
  Button,
  ApiError,
  ConfirmLabel,
  ConfirmInput,
} from "./styles";
import { ftpAPI } from "api";
import { useTaskStore } from "store/task";

const AddFtpItem = ({ open, setOpen, user }) => {
  const { addTask } = useTaskStore();

  const [project, setProject] = useState("");
  const [apiErr, setApiErr] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    setProject("");
    setApiErr(null);
    const t = setTimeout(() => inputRef.current?.focus(), 0);
    return () => {
      document.body.style.overflow = prevOverflow;
      clearTimeout(t);
    };
  }, [open]);

  const canSubmit = useMemo(() => project.trim().length > 0, [project]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setApiErr(null);

      const data = await ftpAPI.mountProject(project, user);
      addTask({
        name: user,
        id: data?.data.task_id,
        job: `Create FTP Item`,
        state: "pending",
      });

      setOpen(false);
    } catch (err: any) {
      setApiErr(
        err?.response?.data?.detail ||
          err?.response?.data?.message ||
          err?.message ||
          "Failed to add item."
      );
    }
  };

  if (!open) return null;

  return createPortal(
    <Overlay>
      <Dialog role="dialog" aria-modal="true" aria-labelledby="add-item-title">
        <Header>
          <Title id="add-item-title">Add FTP Project</Title>
        </Header>

        <Desc>
          <strong style={{ color: "#1e40af" }}>{user}</strong> 에게 FTP에 새로운
          프로젝트를 추가합니다.
        </Desc>

        {apiErr && <ApiError role="alert">{apiErr}</ApiError>}

        <form
          onSubmit={handleSubmit}
          style={{
            display: "grid",
            gap: 14,
            marginTop: 12,
            paddingTop: 8,
          }}
        >
          <ConfirmLabel>Project name</ConfirmLabel>
          <ConfirmInput
            ref={inputRef}
            value={project}
            onChange={(e) => setProject(e.target.value)}
            placeholder="ex) project_render_test"
            inputMode="text"
          />

          <Actions>
            <Button
              type="button"
              onClick={() => setOpen(false)}
              data-variant="ghost"
            >
              Cancel
            </Button>
            <Button type="submit" data-variant="primary" disabled={!canSubmit}>
              Add
            </Button>
          </Actions>
        </form>
      </Dialog>
    </Overlay>,
    document.body
  );
};

export default AddFtpItem;
